module.exports = __webpack_public_path__ + "img/interviews-empty-state-no-results.9d9282f2.svg";